import React from 'react'
import PredView from './PredView';

export const columnPredRenderer = (xxx) => {
        const { record, value } = xxx
        const {originalData: {isItemRow, id }} = record;
        
        if(!id || !isItemRow) return ''

        const depIds = Array.from(value.map(x => x.from))
        return <PredView depIds={depIds} internal={record["_internal_dep_counter_"]} record={record} />
    }


